let v9476 = typeof location != "undefined";
const THREE = require("three");
if (v9476) {
  THREE.BufferGeometryUtils = require("./BufferGeometryUtils.js")(THREE);
}
const UTILS = require("./utils.js");
const config = require("../config.js");
const {
  createNoise3D
} = require("./noise.js");
const alea = require("../shim/alea.js");
const easing = require("./easing.js").easing;
const vO303 = {
  GRASS: {
    ind: 0,
    power: 2100,
    slopeSton: 0.8,
    genTer: function (p12130, p12131, p12132, p12133) {
      let v9478 = p12130._sample(p12131, p12132, 300);
      let vLN413 = 4;
      v9478 = Math.floor(v9478 * vLN413) / vLN413;
      let v9479 = p12133[this.ind] * 1;
      return v9478 * 18 * p12133[this.ind] * p12130.sizeMlt + v9479;
    }
  },
  MOUNTAIN: {
    ind: 1,
    power: 1900,
    genTer: function (p12134, p12135, p12136, p12137) {
      let v9480 = 0.4 + p12134._sample(p12135, p12136, 200) * 0.3;
      let v9481 = 1 - Math.abs(v9480 - p12134._sample(p12135, p12136, 500)) * 2;
      let v9482 = 0.4 + p12134._sample(p12135, p12136, 400) * 1.4;
      return Math.abs(v9481 * v9482 * (p12134.mntMlt * 220) * p12137[this.ind]) * p12134.sizeMlt;
    }
  },
  SNOW: {
    ind: 2,
    forceCol: "SNOW",
    slopeSton: 0.75,
    earthLoc: 0.8,
    power: 1000,
    genTer: function (p12138, p12139, p12140, p12141) {
      let v9483 = p12138._sample(p12139, p12140, 300);
      let vLN313 = 3;
      v9483 = Math.floor(v9483 * vLN313) / vLN313;
      let v9484 = p12141[this.ind] * 90;
      return v9483 * 15 * p12141[this.ind] * p12138.sizeMlt + v9484;
    }
  },
  HILLS: {
    ind: 3,
    power: 2100,
    slopeSton: 0.7,
    forceCol: "GRASS",
    genTer: function (p12142, p12143, p12144, p12145) {
      let v9485 = 1 - p12142._sample(p12143, p12144, 2000) * 2;
      let v9486 = 0.4 + p12142._sample(p12143, p12144, 400) * 0.4;
      return Math.abs(v9485 * v9486 * (p12142.mntMlt * -100) * p12145[this.ind]) * p12142.sizeMlt;
    }
  }
};
const v9487 = Object.keys(vO303).length;
var vA534 = [];
for (var v9488 in vO303) {
  if (vO303.hasOwnProperty(v9488)) {
    vA534.push(v9488);
  }
}
const vO304 = {
  TREE: {
    max: 2000,
    sample: 300,
    maxHeight: 230,
    biomes: ["GRASS", "SNOW", "HILLS"],
    biomeCols: {
      SNOW: ["#484d35", "#4d4b35", "#5c5a3c"]
    },
    biomeCoats: {
      SNOW: "#e8fdff"
    },
    check: function (p12146, p12147) {
      return p12146 != "MOUNTAIN" && p12147 != "MOUNTAIN" && p12146 != "DIRT" && p12147 != "DIRT" && p12146 != "SAND" && p12147 != "SAND";
    },
    rate: function () {
      return 0.18;
    }
  },
  STUMP: {
    max: 200,
    sample: 300,
    maxHeight: 600,
    biomes: ["GRASS", "SNOW", "HILLS"],
    check: function (p12148, p12149) {
      return p12148 != "MOUNTAIN" && p12149 != "MOUNTAIN";
    },
    rate: function () {
      return 0.02;
    }
  },
  LOOT: {
    max: 50,
    sample: 300,
    biomes: ["GRASS", "SNOW", "HILLS"],
    check: function (p12150, p12151) {
      return p12150 != "MOUNTAIN" && p12151 != "MOUNTAIN";
    },
    rate: function () {
      return 0.02;
    }
  },
  ROCK: {
    max: 500,
    sample: 300,
    maxHeight: 400,
    biomes: ["GRASS", "SNOW", "HILLS"],
    biomeCoats: {
      SNOW: "#e8fdff"
    },
    check: function () {
      return true;
    },
    rate: function () {
      return 0.075;
    }
  },
  BUSH: {
    sample: 400,
    maxHeight: 200,
    client: true,
    biomes: ["GRASS", "SNOW", "HILLS"],
    biomeCols: {
      SNOW: ["#484d35"]
    },
    biomeCoats: {
      SNOW: "#e8fdff"
    },
    check: function (p12152, p12153) {
      return p12152 != "MOUNTAIN" && p12153 != "MOUNTAIN";
    },
    rate: function () {
      return 0.05;
    }
  },
  GRASS: {
    sample: 400,
    maxHeight: 200,
    countM: 1,
    client: true,
    biomes: ["GRASS", "HILLS"],
    biomeCols: {
      GRASS: ["#4d5928"],
      HILLS: ["#4d5928"]
    },
    check: function (p12154, p12155) {
      return false;
    }
  }
};
const vF83 = p12156 => p12156.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (p12157, p12158, p12159, p12160) => "#" + p12158 + p12158 + p12159 + p12159 + p12160 + p12160).substring(1).match(/.{2}/g).map(p12161 => parseInt(p12161, 16));
var v9489 = new THREE.Vector3();
var v9490 = new THREE.Vector3();
var v9491 = new THREE.Vector3();
const vLN252 = 25;
const vLN57 = 5.7;
class Terrain extends THREE.Object3D {
  static fromConfig(p12162) {
    return new Terrain(p12162.terrainSeed, p12162.terrainWidth, p12162.terrainHeight, p12162.sizeMlt, p12162.terrainMntMlt, p12162.terrainDrtCol, p12162.terrainGrsCol, p12162.terrainMntCol, p12162.terrainSnwCol, p12162.terrainSndCol, p12162.terrainTSeed, p12162.terrainEase);
  }
  constructor(p12163, p12164, p12165, p12166, p12167, p12168, p12169, p12170, p12171, p12172, p12173, p12174) {
    function f1543(p12175, p12176, p12177, p12178) {
      var v9492 = p12177 + "_" + p12178;
      if (!vO305[v9492]) {
        vO305[v9492] = [];
      }
      vO305[v9492].push({
        i: p12175,
        c: p12176
      });
    }
    super();
    p12166 = vLN57;
    this.name = "Terrain";
    this.sizeMlt = p12166;
    this.sizeX = UTILS.limitMM(p12164, config.minTerrainSize, config.maxTerrainSize);
    this.sizeY = UTILS.limitMM(p12165, config.minTerrainSize, config.maxTerrainSize);
    this.edgeSize = 500;
    this.mntMlt = UTILS.limitMM(p12167, config.minMountainMlt, config.maxMountainMlt);
    this.COLORS = {
      DIRT: vF83(p12168 || "#8c6835"),
      GRASS: vF83(p12169 || "#4a6904"),
      MOUNTAIN: vF83(p12170 || "#a0a0a0"),
      SAND: vF83(p12172 || "#967f51"),
      SNOW: vF83(p12171 || "#e8fdff"),
      HILLS: vF83(p12169 || "#4a6904")
    };
    this.ease = easing[Terrain.EASE_LIST[p12174] || "easeInOutQuint"];
    this.MAP_OBJS = vO304;
    this.BIOME_INDEXES = vA534;
    this.noise3D = createNoise3D(alea(p12163 + ""));
    this.noise3DObjs = p12173 ? createNoise3D(alea(p12173 + "")) : null;
    this.sampleIndex3D = 0;
    this.genObjs = !!p12173;
    this.objPos = {};
    for (var v9524 in vO304) {
      if (vO304.hasOwnProperty(v9524)) {
        this.objPos[v9524] = [];
      }
    }
    let v9494 = Math.floor(this.sizeX / vLN252);
    let v9495 = Math.floor(this.sizeY / vLN252);
    this.xSegmentCount = v9494;
    this.ySegmentCount = v9495;
    let v9496 = this.sizeX / v9494;
    let v9497 = this.sizeY / v9495;
    this.xSegmentSize = v9496;
    this.ySegmentSize = v9497;
    let v9498 = new THREE.BufferGeometry();
    let v9499 = v9494 * v9495 * 6;
    let v9500 = new THREE.BufferAttribute(new Float32Array(v9499 * 3), 3);
    v9498.setAttribute("position", v9500);
    let v9501 = new THREE.BufferAttribute(new Float32Array(v9499 * 3), 3, true);
    this.vertPositions = v9500;
    this.terrainPoints = (v9494 + 1) * (v9495 + 1);
    this.terrainHeights = new Float32Array(this.terrainPoints);
    this.biomeSegs = {};
    for (let vLN01536 = 0; vLN01536 < v9494 + 1; vLN01536++) {
      for (let vLN01537 = 0; vLN01537 < v9495 + 1; vLN01537++) {
        let v9502 = vLN01536 + vLN01537 * (v9494 + 1);
        let v9503 = this._vertPos(vLN01536, v9496, this.sizeX);
        let v9504 = this._vertPos(vLN01537, v9497, this.sizeY);
        let [v9505, v9506] = this.evaluate(v9503, v9504);
        this.terrainHeights[v9502] = v9505;
        var vLN01538 = 0;
        var vLN01539 = 0;
        for (var v9507 in vO303) {
          if (vO303.hasOwnProperty(v9507) && v9506[vO303[v9507].ind] > vLN01539) {
            vLN01539 = v9506[vO303[v9507].ind];
            vLN01538 = vO303[v9507].ind;
          }
        }
        this.biomeSegs[vLN01536 + "_" + vLN01537] = {
          i: vLN01538
        };
      }
    }
    var vO305 = {};
    for (let vLN01540 = 0; vLN01540 < v9494; vLN01540++) {
      for (let vLN01541 = 0; vLN01541 < v9495; vLN01541++) {
        let v9508 = vLN01540 + vLN01541 * v9494;
        let v9509 = v9508 * 6;
        let v9510 = this._vertPos(vLN01540, v9496, this.sizeX);
        let v9511 = this._vertPos(vLN01541, v9497, this.sizeY);
        let vA535 = [v9510, v9511, this.terrainHeight(vLN01540, vLN01541)];
        let vA536 = [v9510 + v9496, v9511, this.terrainHeight(vLN01540 + 1, vLN01541)];
        let vA537 = [v9510 + v9496, v9511 + v9497, this.terrainHeight(vLN01540 + 1, vLN01541 + 1)];
        let vA538 = [v9510, v9511 + v9497, this.terrainHeight(vLN01540, vLN01541 + 1)];
        v9500.setXYZ(v9509, ...vA535);
        v9500.setXYZ(v9509 + 1, ...vA536);
        v9500.setXYZ(v9509 + 2, ...vA537);
        v9500.setXYZ(v9509 + 3, ...vA537);
        v9500.setXYZ(v9509 + 4, ...vA538);
        v9500.setXYZ(v9509 + 5, ...vA535);
        var v9512 = this.biomeSegs[vLN01540 + "_" + vLN01541];
        let v9513 = this._centroid3D(vA535, vA536, vA537);
        let v9514 = this._centroid3D(vA537, vA538, vA535);
        let v9515 = this._normal3D(vA535, vA536, vA537);
        v9512.c = this.evaluateColor(v9513, v9515, v9512.i);
        var v9516 = Math.max(v9513[2], v9514[2]);
        if (this.genObjs) {
          for (var v9517 in vO304) {
            if (vO304.hasOwnProperty(v9517) && vO304[v9517].biomes.indexOf(vA534[v9512.i]) >= 0 && (!vO304[v9517].maxHeight || !(vO304[v9517].maxHeight <= v9516)) && vO304[v9517].check(v9512.c)) {
              this.evaluateObj(v9513, vA535, vA536, vA537, v9512.i, v9517, vO304[v9517].client && !v9476);
              this.evaluateObj(v9514, vA537, vA538, vA535, v9512.i, v9517, vO304[v9517].client && !v9476);
            }
          }
        }
        if (v9476) {
          let v9518 = this.calcAOWeight(vLN01540, vLN01541);
          let v9519 = this.calcAOWeight(vLN01540 + 1, vLN01541);
          let v9520 = this.calcAOWeight(vLN01540 + 1, vLN01541 + 1);
          let v9521 = this.calcAOWeight(vLN01540, vLN01541 + 1);
          var v9523 = this.COLORS[v9512.c];
          f1543(v9509, this._weightColor(v9523, v9518), vLN01540 - 0.5, vLN01541 - 0.5);
          f1543(v9509 + 1, this._weightColor(v9523, v9519), vLN01540 + 0.5, vLN01541 - 0.5);
          f1543(v9509 + 2, this._weightColor(v9523, v9520), vLN01540 + 0.5, vLN01541 + 0.5);
          f1543(v9509 + 3, this._weightColor(v9523, v9520), vLN01540 + 0.5, vLN01541 + 0.5);
          f1543(v9509 + 4, this._weightColor(v9523, v9521), vLN01540 - 0.5, vLN01541 + 0.5);
          f1543(v9509 + 5, this._weightColor(v9523, v9518), vLN01540 - 0.5, vLN01541 - 0.5);
        }
      }
    }
    var v9523;
    if (v9476) {
      for (var v9524 in vO305) {
        if (vO305.hasOwnProperty(v9524)) {
          v9523 = [0, 0, 0];
          for (var vLN01542 = 0; vLN01542 < vO305[v9524].length; ++vLN01542) {
            v9501.setXYZ(vO305[v9524][vLN01542].i, ...vO305[v9524][vLN01542].c);
          }
        }
      }
    }
    vO305 = null;
    this.biomeSegs = null;
    v9498.setAttribute("color", new THREE.BufferAttribute(new Uint8Array(v9501.array), 3, true));
    if (v9476) {
      v9498 = THREE.BufferGeometryUtils.mergeVertices(v9498);
      v9498.computeVertexNormals(true);
      var v9525 = new THREE.StrippedLambertMaterial({
        color: 9211020,
        flatShading: false,
        vertexColors: true
      });
      this.baseMesh = new THREE.Mesh(v9498, v9525);
      this.baseMesh.receiveShadow = true;
      this.baseMesh.scale.set(p12166, p12166, 1);
      this.add(this.baseMesh);
    }
    this._raycastRay = new THREE.Ray();
    this._raycastTriA = new THREE.Vector3();
    this._raycastTriB = new THREE.Vector3();
    this._raycastTriC = new THREE.Vector3();
    this._raycastTriangle = new THREE.Triangle();
    this._raycastNormal = new THREE.Vector3();
    this._raycastTarget = new THREE.Vector3();
    this._raycastClosestTarget = new THREE.Vector3();
  }
  generateTexture(p12179, p12180) {
    var v9526 = document.createElement("canvas");
    v9526.width = p12179;
    v9526.height = p12180;
    var v9527 = v9526.getContext("2d");
    v9527.fillStyle = "#ffffff";
    v9527.fillRect(0, 0, p12179, p12180);
    v9527.fillStyle = "#000000";
    v9527.fillRect(0, 0, p12179 / 2, p12180 / 2);
    return v9526;
  }
  evaluateObj(p12181, p12182, p12183, p12184, p12185, p12186, p12187) {
    if (!(p12181[2] <= -120)) {
      var v9528 = vO304[p12186];
      if (!v9528.max || !(this.objPos[p12186].length >= v9528.max)) {
        let v9529 = this._sample3D(p12181[0], p12181[1], v9528.sample);
        var v9530 = v9528.rate ? v9528.rate(p12185) : null;
        if (v9530 == null || v9529 > 1 - v9530 || v9529 < v9530) {
          var v9531;
          for (var v9532 = Math.floor(v9529 * (v9528.countM || 1)) || 1, vLN01543 = 0; vLN01543 < v9532; vLN01543++) {
            v9531 = this.randomInTriangle(p12182, p12183, p12184, p12181[0], p12181[1]);
            if (!p12187) {
              this.objPos[p12186].push([v9531.x * this.sizeMlt, v9531.z, -(v9531.y * this.sizeMlt), p12185]);
            }
          }
        }
      }
    }
  }
  randomInTriangle(p12188, p12189, p12190, p12191, p12192) {
    p12188 = v9489.set(...p12188);
    p12189 = v9490.set(...p12189);
    p12190 = v9491.set(...p12190);
    var v9533 = this._sample3D(p12191, p12192, 400);
    var v9534 = Math.sqrt(this._sample3D(p12191, p12192, 500));
    return p12188.clone().multiplyScalar(1 - v9534).add(p12189.clone().multiplyScalar(v9534 * (1 - v9533))).add(p12190.clone().multiplyScalar(v9533 * v9534));
  }
  terrainIndex(p12193, p12194) {
    let v9535 = p12193 + p12194 * (this.xSegmentCount + 1);
    if (v9535 < 0 || v9535 >= this.terrainHeights.length) {
      return 0;
    } else {
      return v9535;
    }
  }
  terrainHeight(p12195, p12196) {
    return this.terrainHeights[this.terrainIndex(p12195, p12196)];
  }
  calcAOWeight(p12197, p12198) {
    let v9536 = this._vertPos(p12197, this.xSegmentSize, this.sizeX);
    let v9537 = this._vertPos(p12198, this.ySegmentSize, this.sizeY);
    let v9538 = this._topAngleOnTerrain(v9536 - this.xSegmentSize, this.terrainHeight(p12197 - 1, p12198), v9536, this.terrainHeight(p12197, p12198), v9536 + this.xSegmentSize, this.terrainHeight(p12197 + 1, p12198));
    let v9539 = this._topAngleOnTerrain(v9537 - this.xSegmentSize, this.terrainHeight(p12197, p12198 - 1), v9537, this.terrainHeight(p12197, p12198), v9537 + this.ySegmentSize, this.terrainHeight(p12197, p12198 + 1));
    let v9540 = Math.PI;
    let v9541 = Math.max(v9540 - v9538, 0) / v9540;
    let v9542 = Math.max(v9540 - v9539, 0) / v9540;
    let v9543 = 1 - (1 - v9541) * (1 - v9542);
    if (v9543 >= 0.5) {
      v9543 = 0.65;
    } else if (v9543 >= 0.2) {
      v9543 = 0.3;
    } else if (v9543 >= 0.1) {
      v9543 = 0.25;
    }
    return v9543;
  }
  heightAt(p12199, p12200) {
    p12199 /= this.sizeMlt;
    p12200 /= this.sizeMlt;
    let v9544 = Math.floor(this._worldToLocal(p12199, this.sizeX, this.xSegmentSize));
    let v9545 = Math.floor(this._worldToLocal(p12200, this.sizeY, this.ySegmentSize));
    let v9546 = f1544(this._worldToLocal(p12199), this.xSegmentSize) / this.xSegmentSize;
    let v9547 = f1544(this._worldToLocal(p12200), this.ySegmentSize) / this.ySegmentSize;
    let vI17 = f1545(this.terrainHeight(v9544, v9545), this.terrainHeight(v9544, v9545 + 1), v9547);
    let vI18 = f1545(this.terrainHeight(v9544 + 1, v9545), this.terrainHeight(v9544 + 1, v9545 + 1), v9547);
    return f1545(vI17, vI18, v9546);
  }
  _worldToLocal(p12201, p12202, p12203) {
    return (p12201 + p12202 / 2) / p12203;
  }
  raycast(p12204, p12205, p12206, p12207, p12208, p12209, p12210 = false) {
    p12204 /= this.sizeMlt;
    p12205 /= this.sizeMlt;
    p12207 /= this.sizeMlt;
    p12208 /= this.sizeMlt;
    let v9548 = Math.sqrt(p12207 * p12207 + p12208 * p12208 + p12209 * p12209);
    this._raycastRay.origin.set(p12204, p12205, p12206);
    this._raycastRay.direction.set(p12207, p12208, p12209);
    let v9549;
    let v9550;
    let v9551;
    let v9552 = this._worldToLocal(p12204, this.sizeX, this.xSegmentSize);
    let v9553 = this._worldToLocal(p12205, this.sizeY, this.ySegmentSize);
    let v9554 = v9552 + p12207 / this.xSegmentSize;
    let v9555 = v9553 + p12208 / this.ySegmentSize;
    let v9556 = Math.abs(v9554 - v9552);
    let v9557 = Math.abs(v9555 - v9553);
    let v9558 = Math.floor(v9552);
    let v9559 = Math.floor(v9553);
    let vLN1140 = 1;
    if (v9556 == 0) {
      v9549 = 0;
      v9551 = Number.POSITIVE_INFINITY;
    } else if (v9554 > v9552) {
      v9549 = 1;
      vLN1140 += Math.floor(v9554) - v9558;
      v9551 = (Math.floor(v9552) + 1 - v9552) * v9557;
    } else {
      v9549 = -1;
      vLN1140 += v9558 - Math.floor(v9554);
      v9551 = (v9552 - Math.floor(v9552)) * v9557;
    }
    if (v9557 == 0) {
      v9550 = 0;
      v9551 -= Number.POSITIVE_INFINITY;
    } else if (v9555 > v9553) {
      v9550 = 1;
      vLN1140 += Math.floor(v9555) - v9559;
      v9551 -= (Math.floor(v9553) + 1 - v9553) * v9556;
    } else {
      v9550 = -1;
      vLN1140 += v9559 - Math.floor(v9555);
      v9551 -= (v9553 - Math.floor(v9553)) * v9556;
    }
    for (; vLN1140 > 0; vLN1140--) {
      let v9560 = this._raycastVisit(v9558, v9559, p12204, p12205, p12206, p12207, p12208, p12209, v9548, p12210);
      if (v9560) {
        let v9561 = this._raycastClosestTarget;
        v9561.x *= this.sizeMlt;
        v9561.y *= this.sizeMlt;
        return v9561;
      }
      if (v9551 > 0) {
        v9559 += v9550;
        v9551 -= v9556;
      } else {
        v9558 += v9549;
        v9551 += v9557;
      }
    }
  }
  _raycastVisit(p12211, p12212, p12213, p12214, p12215, p12216, p12217, p12218, p12219, p12220) {
    let v9562 = p12211 + p12212 * this.xSegmentCount;
    let v9563 = Number.POSITIVE_INFINITY;
    let v9564 = false;
    for (let v9565, vLN01544 = 0; vLN01544 < 2; vLN01544++) {
      v9565 = v9562 * 6 + vLN01544 * 3;
      this._raycastTriA.set(this.vertPositions.getX(v9565), this.vertPositions.getY(v9565), this.vertPositions.getZ(v9565));
      this._raycastTriB.set(this.vertPositions.getX(v9565 + 1), this.vertPositions.getY(v9565 + 1), this.vertPositions.getZ(v9565 + 1));
      this._raycastTriC.set(this.vertPositions.getX(v9565 + 2), this.vertPositions.getY(v9565 + 2), this.vertPositions.getZ(v9565 + 2));
      let v9566 = this._raycastRay.intersectTriangle(this._raycastTriA, this._raycastTriB, this._raycastTriC, true, this._raycastTarget);
      if (v9566) {
        let v9567 = v9566.distanceTo(this._raycastRay.origin);
        if (v9567 < v9563 && v9567 < p12219) {
          v9563 = v9567;
          v9564 = true;
          this._raycastClosestTarget.copy(v9566);
          this._raycastTriangle.set(this._raycastTriA, this._raycastTriB, this._raycastTriC);
        }
      }
    }
    if (p12220 && v9564) {
      this._raycastTriangle.getNormal(this._raycastNormal);
    }
    return v9564;
  }
  evaluate(p12221, p12222) {
    let vLN01545 = 0;
    this.sampleIndex = 0;
    let vA539 = [];
    for (let vLN01546 = 0; vLN01546 < v9487; vLN01546++) {
      var v9568 = vO303[vA534[vLN01546]];
      var v9569 = v9568.power || 1800;
      vA539.push(this._sample(p12221, p12222, v9569));
    }
    let v9570 = vA539.reduce((p12223, p12224) => p12223 + p12224, 0);
    vA539 = vA539.map((p12225, p12226) => [p12226, p12225 / v9570]);
    vA539 = vA539.sort((p12227, p12228) => p12228[1] - p12227[1]);
    let vO306 = {};
    let [v9571, v9572] = vA539[0];
    vO306[v9571] = this._easeTerrain(v9572 / (v9572 + vA539[1][1]));
    for (let vLN1141 = 1; vLN1141 < vA539.length; vLN1141++) {
      let [v9573, v9574] = vA539[vLN1141];
      vO306[v9573] = this._easeTerrain(v9574 / (v9572 + v9574));
    }
    for (var v9575 in vO303) {
      if (vO303.hasOwnProperty(v9575)) {
        vLN01545 += vO303[v9575].genTer(this, p12221, p12222, vO306);
      }
    }
    let v9576 = this._calcEdgeFade(p12221, this.sizeX) * this._calcEdgeFade(p12222, this.sizeY);
    vLN01545 *= v9576;
    vLN01545 += (v9576 - 1) * 2000;
    if (Math.abs(p12221) >= this.sizeX / 2 || Math.abs(p12222) >= this.sizeY / 2) {
      vLN01545 = -1000;
    }
    return [vLN01545, vO306];
  }
  evaluateColor(p12229, p12230, p12231) {
    let v9577;
    let v9578 = p12229[2];
    let v9579 = Math.atan2(Math.abs(p12230[0]), Math.abs(p12230[2]));
    let v9580 = Math.atan2(Math.abs(p12230[1]), Math.abs(p12230[2]));
    let v9581 = 1 - v9579 / (Math.PI * 2);
    let v9582 = 1 - v9580 / (Math.PI * 2);
    v9577 = v9578 > 100 ? "MOUNTAIN" : v9578 > 5 ? "GRASS" : "DIRT";
    var v9583 = vO303[vA534[p12231]];
    if (v9583.forceCol) {
      v9577 = v9583.forceCol;
    }
    if (v9578 > 950) {
      v9577 = "SNOW";
    }
    if (v9578 <= -10) {
      v9577 = "SAND";
    } else if (v9578 > 250) {
      v9577 = "MOUNTAIN";
    } else if (v9581 * v9582 <= (v9583.slopeSton || 0.85)) {
      v9577 = "MOUNTAIN";
    }
    return v9577;
  }
  _sample(p12232, p12233, p12234) {
    this.sampleIndex++;
    return this.noise3D(p12232 / p12234, p12233 / p12234, this.sampleIndex * 10000) / 2 + 0.5;
  }
  _sample3D(p12235, p12236, p12237) {
    this.sampleIndex3D++;
    return this.noise3DObjs(p12235 / p12237, p12236 / p12237, this.sampleIndex3D * 10000) / 2 + 0.5;
  }
  _easeTerrain(p12238) {
    return this.ease(this.ease(p12238));
  }
  _calcEdgeFade(p12239, p12240) {
    if (Math.abs(p12239) >= p12240 / 2) {
      return 0;
    }
    let v9584 = (Math.abs(p12239) - p12240 / 2 + this.edgeSize) / this.edgeSize;
    v9584 = 1 - Math.max(v9584, 0);
    return easing.easeOutQuint(v9584);
  }
  _vertPos(p12241, p12242, p12243) {
    return p12241 * p12242 - p12243 / 2;
  }
  _avgPos(p12244, p12245) {
    return [(p12244[0] + p12245[0]) / 2, (p12244[1] + p12245[1]) / 2, (p12244[2] + p12245[2]) / 2];
  }
  _centroid3D(p12246, p12247, p12248) {
    let v9585 = (p12246[0] + p12247[0] + p12248[0]) / 3;
    let v9586 = (p12246[1] + p12247[1] + p12248[1]) / 3;
    let v9587 = (p12246[2] + p12247[2] + p12248[2]) / 3;
    return [v9585, v9586, v9587];
  }
  _normal3D(p12249, p12250, p12251) {
    let v9588 = p12251[0] - p12250[0];
    let v9589 = p12251[1] - p12250[1];
    let v9590 = p12251[2] - p12250[2];
    let v9591 = p12249[0] - p12250[0];
    let v9592 = p12249[1] - p12250[1];
    let v9593 = p12249[2] - p12250[2];
    let v9594 = v9589 * v9593 - v9590 * v9592;
    let v9595 = v9590 * v9591 - v9588 * v9593;
    let v9596 = v9588 * v9592 - v9589 * v9591;
    let v9597 = Math.sqrt(v9594 * v9594 + v9595 * v9595 + v9596 + v9596);
    return [v9594 / v9597, v9595 / v9597, v9596 / v9597];
  }
  _topAngleOnTerrain(p12252, p12253, p12254, p12255, p12256, p12257) {
    let v9598 = Math.atan2(p12253 - p12255, p12252 - p12254);
    let v9599 = Math.atan2(p12257 - p12255, p12256 - p12254);
    if (v9598 < 0) {
      v9598 += Math.PI * 2;
    }
    return v9598 - v9599;
  }
  _weightColor(p12258, p12259) {
    return p12258.map(p12260 => p12260 * (1 - p12259));
  }
}
Terrain.CONFIG_PROPS = ["terrainSeed", "terrainTSeed", "terrainWidth", "terrainHeight", "sizeMlt", "terrainMntMlt", "terrainDrtCol", "terrainGrsCol", "terrainMntCol", "terrainSnwCol", "terrainSndCol", "terrainEase"];
Terrain.EASE_LIST = Object.keys(easing);
Terrain.BIOME_LIST = Object.keys(vO303);
function f1544(p12261, p12262) {
  return (p12261 % p12262 + p12262) % p12262;
}
function f1545(p12263, p12264, p12265) {
  return p12263 * (1 - p12265) + p12264 * p12265;
}
module.exports = Terrain;